import { useState } from "react";
import { Link, Navigate, useNavigate } from "react-router-dom";
import { GraduationCap, ArrowRight, KeyRound } from "lucide-react";
import { toast } from "sonner";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { useStudentAuth } from "@/lib/studentAuth";
import { formatApiError } from "@/lib/api";

export default function StudentLogin() {
  const { student, login } = useStudentAuth();
  const nav = useNavigate();
  const [phone, setPhone] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  if (student && student.id) return <Navigate to="/student" replace />;

  const onSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await login(phone, password);
      toast.success("Welcome back!");
      nav("/student");
    } catch (err) {
      toast.error(formatApiError(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen bg-[#0B192C] relative overflow-hidden grid place-items-center px-4 text-white">
      <div className="vk-grain" />
      <div className="relative w-full max-w-md">
        <Link to="/" className="flex items-center gap-2 mb-8">
          <span className="w-10 h-10 rounded-md bg-white/5 border border-white/10 grid place-items-center">
            <GraduationCap size={22} className="text-[#FF6B35]" />
          </span>
          <div className="font-display text-xl font-bold uppercase tracking-tight">Vikramshila Classes</div>
        </Link>
        <form onSubmit={onSubmit} data-testid="student-login-form" className="rounded-lg border border-white/10 bg-white/5 p-8 backdrop-blur-xl">
          <div className="flex items-center gap-2 text-[#FF6B35]"><KeyRound size={18} /><span className="text-xs uppercase tracking-widest">Student portal</span></div>
          <h1 className="mt-3 font-display text-3xl font-800">Sign in to see your progress</h1>
          <p className="mt-2 text-sm text-white/60">Use your registered phone number and password.</p>

          <div className="mt-6 space-y-4">
            <div>
              <Label htmlFor="s-phone" className="text-white/80">Phone number</Label>
              <Input id="s-phone" data-testid="student-login-phone" value={phone} onChange={(e) => setPhone(e.target.value)} required className="mt-1 bg-white/10 border-white/20 text-white placeholder:text-white/40" />
            </div>
            <div>
              <Label htmlFor="s-pass" className="text-white/80">Password</Label>
              <Input id="s-pass" type="password" data-testid="student-login-password" value={password} onChange={(e) => setPassword(e.target.value)} required className="mt-1 bg-white/10 border-white/20 text-white placeholder:text-white/40" />
            </div>
          </div>

          <button type="submit" disabled={loading} data-testid="student-login-submit" className="vk-btn-primary w-full mt-6 justify-center">
            {loading ? "Signing in…" : (<>Sign In <ArrowRight size={16} /></>)}
          </button>

          <div className="mt-6 text-center text-sm text-white/60">
            First time here?{" "}
            <Link to="/student/register" data-testid="student-register-link" className="text-[#FF6B35] hover:underline">Register with your enrollment code</Link>
          </div>
          <Link to="/" className="mt-4 block text-center text-xs text-white/50 hover:text-white">← Back to site</Link>
        </form>
      </div>
    </div>
  );
}
